export const CLINIC = {
  name: "Holistic Wellness & Aesthetics",
  tagline: "An Integrated Approach to Health & Wellbeing",
  motto: "Reviving Health Naturally",
  practitioner: "Harleen Kaur",
  credentials: "BHMS, MD (Hom), RSHom",
  roles: ["Homoeopathic Practitioner", "Nutrition & Health Coach", "Certified Skin Aesthetician"],
  phone: "+44 7440 297801",
  email: "holisticwellnessandaesthetics@gmail.com",
  website: "www.holisticwellnessandaesthetics.co.uk",
};

export const LOCATIONS = [
  {
    id: "marylebone",
    country: "United Kingdom",
    flag: "🇬🇧",
    name: "Light Centre Marylebone",
    address: "Unit 4, 10 Portman Square, London W1H 6AZ",
    hours: ["Monday: 11:00am – 2:00pm", "Friday: 2:30pm – 5:30pm"],
    note: "By appointment",
    currency: "£",
  },
  {
    id: "hounslow",
    country: "United Kingdom",
    flag: "🇬🇧",
    name: "Hounslow Branch",
    address: "51 Greencroft Road, Hounslow, London, United Kingdom",
    hours: ["Monday – Saturday: 11:00am – 5:30pm"],
    note: "By appointment only",
    currency: "£",
  },
  {
    id: "mumbai",
    country: "India",
    flag: "🇮🇳",
    name: "Mumbai Clinic",
    address: "Shop No 1, Rajendra Vihar CHS, Evershine Nagar, Malad-W, Mumbai 400064, Maharashtra, India",
    hours: ["Monday – Saturday: 4:30pm – 9:00pm IST", "Sunday: 10:30am – 1:00pm IST"],
    note: "By appointment",
    currency: "₹",
  },
];

export const CATEGORY_META = {
  "Homoeopathy & Integrated Wellness": {
    blurb:
      "Individualised homoeopathic consultations for acute and chronic conditions — a holistic approach considering your health history, lifestyle, nutrition, stress, sleep and emotional wellbeing.",
  },
  "Nutrition, Lifestyle & Health Coaching": {
    blurb:
      "Personalised nutrition and lifestyle guidance to help you build sustainable habits, improve energy, manage stress and support long-term wellbeing.",
  },
  "Skin & Aesthetic Treatments": {
    blurb:
      "Evidence-informed, non-surgical skin and aesthetic treatments to support skin health, rejuvenation and natural confidence — skin boosters, microneedling, Profhilo®, mesotherapy and more.",
  },
};

export const CATEGORY_ORDER = [
  "Homoeopathy & Integrated Wellness",
  "Nutrition, Lifestyle & Health Coaching",
  "Skin & Aesthetic Treatments",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1787496994323-59ac5cff09f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzcyUyMGNsaW5pYyUyMGludGVyaW9yfGVufDB8fHx8MTc4NzYwOTIzM3ww&ixlib=rb-4.1.0&q=85",
  skin: "https://images.unsplash.com/photo-1731514771613-991a02407132?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxza2luJTIwYWVzdGhldGljJTIwdHJlYXRtZW50fGVufDB8fHx8MTc4NzYwOTIzM3ww&ixlib=rb-4.1.0&q=85",
  homoeopathy: "https://images.unsplash.com/photo-1624275279032-a6d3ceb61c71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxob21vZW9wYXRoeSUyMG5hdHVyYWwlMjBtZWRpY2luZXxlbnwwfHx8fDE3ODc2MDkyMzN8MA&ixlib=rb-4.1.0&q=85",
  nutrition: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwbnV0cml0aW9uJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc4NzYwOTIzM3ww&ixlib=rb-4.1.0&q=85",
};

export function categoryImage(category) {
  if (category === "Skin & Aesthetic Treatments") return IMAGES.skin;
  if (category === "Nutrition, Lifestyle & Health Coaching") return IMAGES.nutrition;
  return IMAGES.homoeopathy;
}
